import { useEffect, type DependencyList } from "react";
import { useIsMounted } from "./use-is-mounted";

export function useAsyncEffect(
  method: (isMounted: React.MutableRefObject<boolean>) => Promise<void>,
  deps?: DependencyList,
) {
  const isMounted = useIsMounted();

  useEffect(() => {
    method(isMounted);
  }, deps);
}
